import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { SaunaIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { InputLabel } from "@material-ui/core";

export const ElectricSaunaForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.NEW_CONNECTION_ELECTRIC_SAUNA>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<SaunaIcon />}
                content={
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Sauna
                        </p>
                }
                useSwitch={
                    <Switch
                        checked={values.newConnectionElectricSauna.value.installed}
                        {...getFieldProps("newConnectionElectricSauna.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.newConnectionElectricSauna.value.installed = checked;
                                values.newConnectionElectricSauna.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.newConnectionElectricSauna.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={values.newConnectionElectricSauna.value.demand.precision}
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.newConnectionElectricSauna.value.demand.unit}
                            value={values.newConnectionElectricSauna.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.newConnectionElectricSauna.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.newConnectionElectricSauna.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
